"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EntellicaNotFoundError = void 0;
const BaseError_1 = require("./BaseError");
class EntellicaNotFoundError extends BaseError_1.BaseError {
    constructor(description = "Not Found") {
        super("EntellicaNotFoundError", 404, description, true);
    }
}
exports.EntellicaNotFoundError = EntellicaNotFoundError;
